/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {TwoColorIconProps} from '../IconTypes';

/**
 * ![CircleInformationIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB3ElEQVR4nMVVPUsDQRA9LPyoNIIGovgD0gmCWAkS5TS7sxvC3YxaRG38ByL6H7TS0n9gYmuvYPws1TbaWfgNdsocai655HajoAsLW+zMm31v5q3j/OfyPK8XNC2Boj2p6Qo0vvD+PJcA/MVsdi7xk8RdoHEdND6Cpve4LRU9SIVrHGOVHIBSoOjYlBjqgTReCOENxSbP5eYHQdNtq8nh+zV4k816A81pUXT20+RQfcnJeKHQGaUm4NwU7M26rtcnNR7F38XV+up7bQSdnMz1O47TJgG3TMLXdFfQinYcl0H526DpzeLuQhVA0d5vuYeoFsVvAKno2hxAlQkpkwLMWn3ev6oCaHqyePIO8y8UoiXAU/gFz6YAofzlQGCFG3Y04WNLFLmQH2YAUHRgBaDwMjwDJUPAazqdbnddt4PPdgC0G/Iff9HA5yFXPw35EfsuokLNoPFwNBfY32eAGciPgsY7oXGTLSGmRe+VKvTUTDNbbpxgE1ImGeRrAxA0L4hWIl7EBmWo6lQIbyyTyXQLjVMsYpN2Ljc0O15stWy5tjxDlPcK/ycNk1cFp1TgOS0nx3PjhxOmiy03TviwoMw5t7BV8lrK5hLsisGcKLzkiQ+mns8ai9yKkW756/UBaE/jI98HxuQAAAAASUVORK5CYII=)
 */
export const CircleInformationIcon = ({
  size = 'md',
  width,
  height,
  secondaryColor = 'transparent',
  secondaryColorClass = '',
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: TwoColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill={typeof secondaryColor === 'string' ? secondaryColor : secondaryColor.css}
        className={secondaryColorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M23 12a11 11 0 1 1-22 0 11 11 0 0 1 22 0Zm-9.5-4.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-.77 3.96a1 1 0 1 0-1.96-.42l-1.04 4.86a2.77 2.77 0 0 0 4.31 2.83l.24-.17a1 1 0 1 0-1.16-1.62l-.24.17a.77.77 0 0 1-1.2-.79l1.05-4.86Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
